import useImg from '../../../assets/images/user.png'
import { renderTimeMonth } from '../../../../Web/Common/Function';
import { BsChevronLeft } from 'react-icons/bs';

const ItemComment = ({ data, waitCm, replayEV }) => {

    return (
        <div className="border rounded p-2 mt-2">
            <div className='row mx-0'>
                <div style={{ flex: "0 0 50px" }}>
                    <img src={useImg} width={38} height={38} />
                </div>
                <div className='flex-fill d-flex align-items-start flex-column justify-content-center nfs-10'>
                    <p>{waitCm ? data?.name : data?.comenter?.fullname}</p>
                    {!waitCm && <p>{renderTimeMonth(data.created_at)}</p>}
                </div>

                <p className='nfs-12 fw400 my-3' style={{ flex: "0 0 100%" }}>
                    {waitCm
                        ? `آدرس : ${data.address}`
                        : data.text
                    }
                </p>
                {replayEV &&
                    <div className='nfs-12 d-flex' style={{ flex: "0 0 100%" }}>
                        <span className='mr-auto' onClick={() => replayEV()}>
                            {/* <span className='mr-auto' onClick={() => replayEV({ visible: true, data: data.id })}> */}
                            ثبت پاسخ
                            <BsChevronLeft size={18} className='mr-1' />
                        </span>
                    </div>
                }
            </div>
        </div>
    )
}

export default ItemComment;